'use strict';

var arrayWithoutHoles = require('./arrayWithoutHoles.js');
var iterableToArray = require('./iterableToArray.js');
var nonIterableSpread = require('./nonIterableSpread.js');

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
